"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToJobModal = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
const input_1 = require("../../components/input/input");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const store_1 = require("../../store");
const job_card_1 = require("../job.assign.modal/job.card");
const collection_move_modal_ctrl_1 = require("./collection.move.modal.ctrl");
const collection_move_modal_style_1 = require("./collection.move.modal.style");
(0, theme_1.addStyles)(collection_move_modal_style_1.Style);
class CollectionMoveToJobModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.selectedJob = null;
        this.ctrl = new collection_move_modal_ctrl_1.CollectionMoveModalCtrl(collections);
        this.collections = collections;
        this.jobInputState = new input_state_1.InputState('Job');
        this.addState(this.jobInputState);
        this.autoMenu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: this.jobInputState,
            options: () => this.jobOptions,
            optionView: (option, nameParts) => this.viewJobCard(option, nameParts),
            onselect: option => this.selectJob(option)
        });
    }
    get jobOptions() {
        const rawJobs = store_1.AppStore.Tag.all;
        const jobs = rawJobs
            .filter((job) => Boolean(store_1.AppStore.TagSummary.get(job.objectId)))
            .map(tagObject => ({ id: tagObject.objectId, value: tagObject.name }));
        return jobs;
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.jobContent }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_CONFIRM, { count: this.ctrl.collections.length })),
                this.jobSelector()
            ]),
            (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.menu }, this.autoMenu.view())
        ]);
    }
    viewJobCard(option, nameParts) {
        return { view: job_card_1.JobModalCard.viewCard({ tag: store_1.AppStore.Tag.get(option.id) }, nameParts), action: () => this.selectJob(option) };
    }
    jobSelector() {
        if (!this.selectedJob) {
            return input_1.Input.view(this.jobInputState);
        }
        return job_card_1.JobModalCard.viewChip({ tag: store_1.AppStore.Tag.get(this.selectedJob), cancel: () => this.selectJob() });
    }
    validate() {
        if (!this.jobInputState._value && !this.selectedJob) {
            this.jobInputState.setError((0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_JOB_INPUT_ERROR));
        }
        else {
            this.jobInputState.setError('');
        }
    }
    submit() {
        const tagName = this.selectedJob != null ? store_1.AppStore.Tag.get(this.selectedJob).name : this.jobInputState.value;
        return services_1.Services.Collection.move(this.collections, tagName);
    }
    selectJob(option) {
        if (option != null) {
            this.selectedJob = option.id;
        }
        else {
            this.selectedJob = null;
            this.jobInputState.setValue('');
        }
    }
}
exports.CollectionMoveToJobModal = CollectionMoveToJobModal;
tslib_1.__decorate([
    mobx_1.observable
], CollectionMoveToJobModal.prototype, "selectedJob", void 0);
tslib_1.__decorate([
    mobx_1.computed
], CollectionMoveToJobModal.prototype, "jobOptions", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionMoveToJobModal.prototype, "selectJob", null);
//# sourceMappingURL=collection.move.job.modal.js.map